import { Util } from "@base/util/Util";

export class Measure {
  static m = "m";
  static cm = "\u339D";
  static mm = "\u339C";
  static m2 = "\u33A1";

  static toM(len: number, decimals: number = 0): string {
    return `${Measure.roundM(len, decimals)}${Measure.m}`;// "mm";
  }
  static toCM(len: number, decimals: number = 0): string {
    return `${Measure.roundCM(len, decimals)}${Measure.cm}`;// "mm";
  }
  static toMM(len: number, decimals: number = 0): string {
    return `${Measure.roundMM(len, decimals)}${Measure.mm}`;// "mm";
  }

  static roundM(meter: number, decimals: number = 0): number {
    return Util.round(meter + 0.00000001, decimals);
  }

  static roundCM(meter: number, decimals: number = 0): number {
    return Util.round(meter * 100 + 0.00000001, decimals);
  }

  static roundMM(meter: number, decimals: number = 0): number {
    return Util.round(meter * 1000 + 0.00000001, decimals);
  }

  static toPercent(percent: number, roundUnits: number = 1): string {
    return "" + Util.round(percent + 0.00000001, roundUnits) + "%";
  }
}
